import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';
import { Button } from '@bechtel/gds';

export const ImportUsersContainerStyled = styled(Box).attrs({ flexDirection: { sm: 'column' } })`
  height: 100vh;
  overflow: hidden;
`;

export const ImportUsersSubContainerStyled = styled(Box).attrs({
  mx: { sm: '500' },
  mt: { sm: '500' },
})`
  height: 100vh;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.radii[200]};
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
`;

export const ImportUsersInnerBlockStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  flexGrow: { sm: '1' },
})`
  height: 100vh;
  overflow-y: auto;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
`;

export const ImportUserHeadingStyled = styled(Box).attrs({
  flexDirection: { sm: 'row' },
  px: { sm: '500' },
  pt: { sm: '500' },
})`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
`;

export const ImportUserRowStyled = styled(Box).attrs({
  flexDirection: { sm: 'row' },
})`
  cursor: pointer;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
`;

export const FooterButtonStyled = styled(Box).attrs({ p: { sm: '500' }, justifyContent: { sm: 'flex-end' } })`
  background-color: ${({ theme }) => theme.colors.blue[800]};
`;

export const ImportUsersFooterButtonStyled = styled(Button)`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights[600]};
    color: ${theme.colors.bechtel.blue[800]};
    padding: ${theme.spacings[300]} ${theme.spacings[600]};
    white-space: nowrap;
  `}
`;
